import CaseType from '@/components/admin/cases/CaseType'
import CaseTypeList from '@/components/admin/cases/CaseTypeList'
import NewCase from '@/components/admin/cases/NewCase'
import CaseImport from '@/components/admin/cases/import/CaseImport'
import CaseTypeBulkOps from '@/components/admin/cases/bulkops/CaseTypeBulkOps'
import auth from '../auth'

export default [
  {
    path: '/admin/casetype/',
    name: 'CaseTypeList',
    component: CaseTypeList,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/casetype/:id?',
    name: 'CaseType',
    component: CaseType,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/casetype/:id/import',
    name: 'CaseImport',
    component: CaseImport,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/casetype/:id/bulk',
    name: 'CaseTypeBulkOps',
    component: CaseTypeBulkOps,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/casetype/:id/new',
    name: 'NewCase',
    component: NewCase,
    beforeEnter: auth.ifAuthenticated
  },
]
